import React from 'react';
import { isEqual } from '../utils/lodash';

import { connect } from 'react-redux';

import { withStyles } from '@mui/styles';
import { ClickAwayListener } from '@mui/material';

import LoaderNew from './LoaderNew';
import CommonStyles from './CommonStyles';
import PredicateNew from './PredicateNew';
import ComponentWrapper from './ComponentWrapper';

import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';

import { getLastRstData } from '../utils';

const styles = {
  container: {
    height: 24,
    display: 'flex',
    position: 'relative',
  },
  selectedRstList: (props) => ({
    flexShrink: 0,
    display: 'flex',
    overflow: 'auto',
    //paddingRight: 2,
    position: 'relative',
    whiteSpace: 'nowrap',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  }),
  arrow: { zIndex: 5, right: '8px', zIndex: '12', top: '2px', position: 'absolute', fontSize: '20px' },
  selectedRstListOverlay: {
    top: 0,
    left: 5,
    right: 5,
    bottom: 0,
    position: 'absolute',
    background: '#EEECF8',
  },
  selectedRstListOverlayFocused: {
    background: '#DBD9E7',
  },
  dropdownList: {
    top: 24,
    left: 0,
    right: 0,
    zIndex: 1099,
    padding: '5px 0',
    maxHeight: '250px',
    overflowY: 'auto',
    overflowX: 'hidden',
    background: '#fff',
    position: 'absolute',
    boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.16)',
    ...CommonStyles.styledScroll,
  },
  rst: {
    fontSize: 12,
    color: '#4E4C4C',
    padding: '3px 0px 3px 5px',
    '&:hover': {
      cursor: 'pointer',
      background: '#DBD9E7',
    },
  },
  rstSelected: {
    background: '#DBD9E7',
  },
  input: {
    ...CommonStyles.input,
    paddingLeft: '8px',
    marginLeft: '-2px',
    width: '-webkit-fill-available',
  }
};

class PredicateChain extends ComponentWrapper {
  state = {
    loaded: true,
    focused: false,
    inputValue: '',
    dropdownSelectedRst: null,
    rstData: {
      ancestors: [],
      dropdown: [],
      original: [],
      selected: [],
    },
    rstDataByConcepts: [],
  };

  componentDidMount() {
    const { rst, disableChain, ancestor } = this.props;
    const { rstData } = this.state;

    if (!disableChain) {
      rstData.selected = Array.isArray(rst) ? rst : [rst];
    }

    if (Array.isArray(ancestor)) this.getRestrictionsByConcepts();
    else this.getRstsData(rstData);
  };

  componentDidUpdate(prevProps) {
    const { rst, disableChain, ancestor } = this.props;
    const { rstData } = this.state;

    if (prevProps.mode !== this.props.mode
      || JSON.stringify(prevProps.rst) !== JSON.stringify(rst)
      || JSON.stringify(prevProps.ancestor) !== JSON.stringify(ancestor)
      || !isEqual(prevProps.light_meta_and_ops, this.props.light_meta_and_ops)) {

      if (!disableChain) {
        if (!rst) rstData.selected = [];
        else rstData.selected = Array.isArray(rst) ? rst : [rst];
      }

      this.setState({ rstData }, () => {
        if (Array.isArray(ancestor)) this.getRestrictionsByConcepts();
        else this.getRstsData(rstData);
      });
    }
  };

  getRestrictionsByConcepts = () => {
    if (this.props.mode !== 'edit') return;
    const { ancestor } = this.props;
    const { setup_rbox_light } = this.props.light_meta_and_ops;

    if (!setup_rbox_light) return;

    this.setState({ loaded: false }, () => {
      const rstDataByConcepts = [];
      let allRstIds = [];

      for (const cid of ancestor) {
        const rstIds = [];

        if (setup_rbox_light[cid] && setup_rbox_light[cid].box.r) {
          Object.keys(setup_rbox_light[cid].box.r).forEach(cid2 => {
            setup_rbox_light[cid].box.r[cid2].forEach(rst => rstIds.push(+rst.id));
          });
        }

        rstDataByConcepts.push({
          cid,
          rstIds,
        });

        rstIds.forEach(rstId => {
          if (!allRstIds.includes(rstId)) allRstIds.push(rstId);
        });
      }

      const newRstData = { ancestors: [], dropdown: [...allRstIds], original: allRstIds, selected: [] };

      this.setState({
        loaded: true,
        rstData: newRstData,
        rstDataByConcepts,
      });
    });
  };

  static getDerivedStateFromProps(props, state) {
    if (props.rst !== state.rst) {
      return {
        rst: props.rst,
      };
    }
    return null;
  };

  getRstsData = (rstData) => {
    const { ancestor } = this.props;
    const { setup_rbox_light } = this.props.light_meta_and_ops;

    const newAncestors = [+ancestor];
    if (rstData) {
      for (let index in rstData.selected) {
        let rstList = [];
        if (setup_rbox_light[newAncestors[+index]] && setup_rbox_light[newAncestors[+index]].box.r) {
          Object.values(setup_rbox_light[newAncestors[+index]].box.r).forEach(rsts => {
            rstList = [...rstList, ...rsts];
          });
        }
        let item = rstList.find(rst => +rstData.selected[+index] === +rst.id);
        if (item && item.oid) newAncestors.push(+item.oid);
        else break;
      }
    }
    const newRstData = { ...rstData, ancestors: newAncestors };

    this.setState({ rstData: newRstData }, () => {
      this.getLastRstRestrictions(newRstData);
    });
  };

  getLastRstRestrictions = (rstData) => {
    if (this.props.mode !== 'edit') return;

    this.setState({ loaded: false }, () => {
      const { setup_rbox_light } = this.props.light_meta_and_ops;

      const lastSelectedRstId = rstData.selected[rstData.selected.length - 1];
      const lastAncestor = rstData.ancestors[rstData.ancestors.length - 2];

      let lastSelectedRst = getLastRstData(+lastSelectedRstId, +lastAncestor, setup_rbox_light);

      if (
        (rstData.selected.length === 0 && this.props.ancestor) ||
        (lastSelectedRst && lastSelectedRst.primitive === '_obj')
      ) {
        const ancestor = lastSelectedRst ? lastSelectedRst.oid : this.props.ancestor;

        const dropdownList = [];

        if (setup_rbox_light[ancestor] && setup_rbox_light[ancestor].box.r) {
          Object.keys(setup_rbox_light[ancestor].box.r).forEach(conceptId => {
            const conceptRestrictions = setup_rbox_light[+ancestor].box.r[conceptId];

            conceptRestrictions.forEach(rst => {
              dropdownList.push(+rst.id);
            });
          });
        }

        let filteredRestrictions = [ ...dropdownList ];

        const newRstData = { ...rstData, dropdown: filteredRestrictions, original: dropdownList };

        this.setState({
          loaded: true,
          rstData: newRstData,
        });
      } else {
        const newRstData = { ...rstData, dropdown: [], original: [] };

        this.setState({
          loaded: true,
          rstData: newRstData,
        });
      }
    });
  };

  onInputChange = (e) => {
    const { setup_rbox_light } = this.props.light_meta_and_ops;
    const { value } = e.target;

    this.setState({ inputValue: value }, () => {
      const { rstData, rstDataByConcepts } = this.state;

      const isMatchRstByInputVal = (rstId, conceptId) => {
        const rst = getLastRstData(rstId, conceptId, setup_rbox_light);
        const rstTitleLC = `[${rst.id}] ${rst.title}`.toLowerCase();
        const valueLC = value.toLowerCase();

        return rstTitleLC.includes(valueLC);
      }

      const filteredRestrictions = [];

      if (Array.isArray(this.props.ancestor)) {
        for (const rstData of rstDataByConcepts) {
          for (const rstId of rstData.rstIds) {
            if (isMatchRstByInputVal(rstId, rstData.cid) && !filteredRestrictions.includes(rstId)) {
              filteredRestrictions.push(rstId);
            }
          }
        }
      } else {
        const ancestors = [...rstData.ancestors];
        const lastAncestor = ancestors[rstData.ancestors.length - 1];

        filteredRestrictions.push(...rstData.original.filter((rstId) => isMatchRstByInputVal(rstId, lastAncestor)));
      }

      const newRstData = {
        ...rstData,
        dropdown: filteredRestrictions,
      };

      this.setState({ rstData: newRstData });
    });
  };

  addRst = (rstId) => {
    const { rstData } = this.state;
    const { disableChain, addInnerRstCb, ancestor } = this.props;

    const newSelected = [...rstData.selected, rstId];
    const newRstData = {
      ...rstData,
      selected: newSelected,
    };

    this.setState({ inputValue: '' });

    let cidByFirstRst;

    if (Array.isArray(ancestor)) {
      cidByFirstRst = this.getConceptIdByRstDataByConcepts(rstId);
      if (!newRstData.ancestors.length && newRstData.selected.length === 1) {
        newRstData.ancestors.push(cidByFirstRst);
      }
    }

    if (addInnerRstCb) {
      addInnerRstCb({
        ...this.props.props,
        rstId,
        newSelected,
        cidByFirstRst,
      });
    }

    if (this.dropdownListRef) this.dropdownListRef.scrollTop = 0;

    if (!disableChain) {
      this.getRstsData(newRstData);
    } else {
      this.closeDropdown();
      this.getRstsData(rstData);
    }
  };

  closeDropdown = () => {
    this.setState({ focused: false, dropdownSelectedRst: null });
  };

  removeRst = (newLength) => {
    const { rstData } = this.state;

    const newSelected = [...rstData.selected];

    newSelected.length = newLength;

    if (this.props.onRemoveRstCb) this.props.onRemoveRstCb(this.props.props, newSelected);

    const newRstData = {
      ...rstData,
      selected: newSelected,
    };

    this.setState(
      {
        rstData: newRstData,
      },
      () => {
        if (!newLength && this.props.multiAncestor) this.getRestrictionsByConcepts();
        else this.getRstsData(newRstData);
      }
    );
  };

  onInputKeyDown = (e) => {
    const { key } = e;

    const { rstData, inputValue, dropdownSelectedRst } = this.state;

    if (!inputValue && key === 'Backspace') this.removeRst(rstData.selected.length - 1);
    if (e.key === 'Escape') {
      e.stopPropagation();

      this.setState({ focused: false });
    }

    if (key === 'ArrowDown') {
      if (dropdownSelectedRst === rstData.dropdown.length - 1) return;
      if (dropdownSelectedRst === null) {
        this.setState({ dropdownSelectedRst: 0 });
      } else {
        this.setState({ dropdownSelectedRst: dropdownSelectedRst + 1 }, () => {
          if (this.dropdownListRef) this.dropdownListRef.scrollTop = this.selectedEl.offsetTop - 76;
        });
      }
    }

    if (key === 'ArrowUp') {
      if (dropdownSelectedRst === 0) {
        this.setState({ dropdownSelectedRst: 0 });
      } else if (dropdownSelectedRst !== null) {
        this.setState({ dropdownSelectedRst: dropdownSelectedRst - 1 });

        if (this.dropdownListRef) this.dropdownListRef.scrollTop = this.selectedEl.offsetTop - 76;
      }
    }

    if (key === 'Enter' && dropdownSelectedRst !== null) {
      this.setState(
        {
          dropdownSelectedRst: null,
        },
        () => {
          this.addRst(rstData.dropdown[dropdownSelectedRst]);

          if (this.props.disableChain) {
            this.inputRef.blur();
          }
        }
      )
    }
  };

  getConceptIdByRstDataByConcepts = (rstId) => {
    const { rstDataByConcepts } = this.state;

    if (!rstDataByConcepts) return;

    for (let rstData of rstDataByConcepts) {
      if (rstData.rstIds.includes(rstId)) return rstData.cid;
    }
  }


  render() {
    const { rstData, focused, hovered, inputValue, loaded, dropdownSelectedRst } = this.state;
    const { maxSelectedRstCount, classes, ancestor, showType, objectTypeOnly } = this.props;
    const { setup_rbox_light } = this.props.light_meta_and_ops;
    const mode = this.props.mode || 'edit';
    
    let lastSelectedRst;
    if (rstData.selected && rstData.ancestors && (rstData.selected.length <= rstData.ancestors.length)) {
      const lastSelectedRstId = rstData.selected[rstData.selected.length - 1];
      const lastAncestor = rstData.ancestors[rstData.ancestors.length - 2];
      lastSelectedRst = getLastRstData(+lastSelectedRstId, +lastAncestor, setup_rbox_light);
    }

    const showInput = maxSelectedRstCount
      ? rstData.selected.length < maxSelectedRstCount && rstData.original.length
      : mode === 'edit' &&
        ((rstData.selected.length === 0 && rstData.original.length) ||
          (lastSelectedRst && lastSelectedRst.primitive === '_obj'));

    return (
      <ClickAwayListener onClickAway={this.closeDropdown}>
        <div className={classes.container}>
          {showInput ? (
            <KeyboardArrowDownOutlinedIcon
              className={classes.arrow}
              onClick={() => {
                this.setState({ focused: !focused });
              }}
              style={{
                transform: `${focused ? 'rotate(180deg)' : ''}`,
              }}
            />
          ) : null}

          <div
            className={`${classes.selectedRstList}`}
          >
            {showInput ? (
              <div
                className={`${classes.selectedRstListOverlay} ${
                  hovered || focused ? classes.selectedRstListOverlayFocused : null
                }`}
              />
            ) : null}

            {rstData.selected.map((rstId, rstIdIndex) => {
              const isFirst = rstIdIndex === 0;
              const concept = rstData.ancestors[rstIdIndex];
              let rst = getLastRstData(+rstId, +concept, setup_rbox_light);

              if (!rst) return (
                <div
                  key={`${rstIdIndex}-${rstId}`}
                  style={{ color: '#DD5900', paddingLeft: '10px' }}
                >
                  {rstId}
                </div>
              );

              const isObj = rst.primitive === '_obj';
              const rstColor = rst.color || 'A285C5';
              const isSingle = rstData.selected.length === 1;
              const isLast = rstIdIndex === rstData.selected.length - 1;

              const position =
                (isFirst && isObj) || (isFirst && !isSingle)
                  ? 'first'
                  : isSingle
                  ? 'single'
                  : !isSingle && isLast && isObj
                  ? 'middle'
                  : isLast
                  ? 'last'
                  : 'middle';

              return (
                <PredicateNew
                  rst={rst}
                  mode={mode}
                  showType={showType}
                  key={`${rstIdIndex}-${rstId}`}
                  color={rstColor}
                  index={rstIdIndex}
                  position={position}
                  onRemoveBtnClick={this.removeRst}
                />
              );
            })}
          </div>

          {showInput ? (
            <React.Fragment>
              <input
                value={inputValue}
                className={`${classes.input}`}
                placeholder="Add predicate"
                onChange={this.onInputChange}
                onKeyDown={this.onInputKeyDown}
                ref={(inputRef) => (this.inputRef = inputRef)}
                onFocus={() => this.setState({ focused: true })}
              />

              {focused && rstData.dropdown ? (
                <div
                  className={classes.dropdownList}
                  ref={(ref) => (this.dropdownListRef = ref)}
                  onMouseOver={() => {
                    this.setState({ dropdownSelectedRst: null });
                  }}
                >
                  {loaded ? (
                    <React.Fragment>
                      {rstData.dropdown.map((rstId, rstIdIndex) => {
                        let conceptId;
                        if (Array.isArray(ancestor)) conceptId = this.getConceptIdByRstDataByConcepts(rstId);
                        else conceptId = rstData.ancestors[rstData.ancestors.length - 1];

                        let rst = getLastRstData(+rstId, +conceptId, setup_rbox_light);

                        if (objectTypeOnly && rst && rst.primitive !== '_obj') return null;

                        return (
                          <div
                            ref={(selectedEl) =>
                              dropdownSelectedRst === rstIdIndex ? (this.selectedEl = selectedEl) : null
                            }
                            key={`${rstIdIndex}-${rstId}`}
                            className={`${classes.rst} ${classes.alignCeneter} ${
                              dropdownSelectedRst === rstIdIndex ? `${classes.rstSelected}` : ''
                            }`}
                            style={{
                              color: rst && rst.color ? `#${rst.color}` : 'c4c4c4',
                            }}
                            onClick={() => {
                              this.addRst(rstId);
                            }}
                          >
                            {rst && rst.primitive === '_obj' ? `[${rstId}] ${rst.title} >` : rst ? `[${rstId}] ${rst.title}` : ''}
                            <span style={{ fontStyle: 'italic', fontSize: '10px' }}>
                              {rst && rst.primitive !== '_obj' ? ` (${rst.type})` : ''}
                            </span>
                          </div>
                        );
                      })}
                    </React.Fragment>
                  ) : (
                    <div className={classes.justifyCenter}>
                      <LoaderNew />
                    </div>
                  )}
                </div>
              ) : null}
            </React.Fragment>
          ) : null}
        </div>
      </ClickAwayListener>
    );
  }
}

export default connect((state) => ({
  light_meta_and_ops: state.meta.light_meta_and_ops,
}))(withStyles(styles)(PredicateChain));
